<template>
  <img v-if="isImage(name)" :src="getURL(name)" class="app-icon" />
  <component :is="name" v-else class="app-icon"> </component>
</template>

<script>
export default {
  name: 'AppIcon',

  props: {
    name: String
  },

  methods: {
    isImage(name) {
      return name.includes('.')
    },

    getURL(name) {
      const components = name.split('.')
      components.splice(components.length - 1, 0, '.')
      if (self.devicePixelRatio > 1) {
        components.splice(components.length - 2, 0, '@2x')
      }

      return `/static/${components.join('')}`
    }
  }
}
</script>

<style lang="scss" scoped rel="stylesheet/scss"></style>
